import errorHandlers from '@/services/error-handlers';
import http from '@/services/http';



export default {
  namespaced: true,

  state: {
    content: {
      AgeGate: {
        metadata: {}
      },
      ContactUs: {
        metadata: {}
      },
      CreateAccountLoyalty: {
        metadata: {
          attributes: []
        }
      },
      CreateAccountStandard: {
        metadata: {
          attributes: []
        }
      },
      DeleteAccountPrompt: {
        metadata: {}
      },
      Loyalty: {
        metadata: {}
      },
      LoyaltyEnrollment: {
        metadata: {}
      },
      LoyaltyEnrollmentSuccess: {
        metadata: {}
      },
      MenuDropdown: {
        metadata: {}
      },
      MobileTippingReceipt: {
        metadata: {}
      },
      MobileTippingSubmit: {
        metadata: {}
      },
      OpenTabAlternatePaymentMethod: {
        metadata: {}
      },
      OpenTabCheckout: {
        metadata: {}
      },
      OpenTabOnboarding1: {
        metadata: {}
      },
      OpenTabOnboarding2: {
        metadata: {}
      },
      OpenTabPaymentDetails: {
        metadata: {}
      },
      OpenTabPaymentMethod: {
        metadata: {}
      },
      OpenTabSplitPaymentOnboarding: {
        metadata: {}
      },
      OpenTabSwapPaymentModal: {
        metadata: {}
      },
      OrderModes: {
        metadata: {}
      },
      OrderSummary: {
        metadata: {
          buttonCta: 'PAY NOW',
          location: 'Pickup Location',
          orderSummary: 'Your Order',
          rewards: 'My Rewards',
          tip: 'Would you like to add a tip?'
        },
        title: 'Order Summary'
      },
      PayAtTable: {
        metadata: {}
      },
      PaymentScreen: {
        metadata: {}
      },
      ReceiptLoyalty: {
        metadata: {}
      },
      ReceiptLoyaltyAward: {
        metadata: {}
      },
      ReceiptStandard: {
        metadata: {}
      },
      ReconfirmPickupLocation: {
        metadata: {}
      },
      Referral: {
        metadata: {}
      },
      SignInLoyalty: {
        metadata: {}
      },
      SignInStandard: {
        metadata: {}
      },
      ThirdPartyLoyaltyLogin: {
        metadata: {}
      }
    },
    locationId: null,
    terms: {
      generalNotice: null,
      privacyPolicy: null,
      termsOfService: null
    }
  },

  getters: {
    content(state) {
      return state.content;
    },

    dynamicContent(state, getters, rootState, rootGetters) {
      const loyaltyOptions = rootGetters['merchant/loyaltyOptions'];

      const content = {
        CreateAccount: state.content.CreateAccountStandard,
        Receipt: state.content.ReceiptStandard,
        SignIn: state.content.SignInStandard,
        ThirdPartyLoyaltyLogin: state.content.ThirdPartyLoyaltyLogin
      };

      if (loyaltyOptions.isVisible) {
        content.CreateAccount = state.content.CreateAccountLoyalty;
        content.Receipt = state.content.ReceiptLoyalty;
        content.SignIn = state.content.SignInLoyalty;
      }

      return content;
    },

    generalNotice(state, getters) {
      const body = getters.terms.generalNotice;

      return {
        body,
        isAvailable: !!body,
        label: state.content.MenuDropdown.metadata?.itemGeneralNotice || 'General Notice'
      };
    },

    terms(state) {
      const sanitizedTerms = {};
      /** removes &ZeroWithSpace spaces that sneak in from portal. */
      Object.entries(state.terms).forEach(([key, val]) => {
        sanitizedTerms[key] = val?.replace(/\u200B/g, '');
      });

      return sanitizedTerms;
    }
  },

  actions: {
    initialize({ dispatch }) {
      dispatch('loadTerms');
      dispatch('updateContent');
    },

    async loadTerms({ commit }) {
      try {
        const response = await http.get('/cardfree-api/v1/merchant/terms-of-service');

        commit('SET_TERMS', response.data);
      }

      catch (error) {
        errorHandlers.silent(error);
      }
    },

    async updateContent({ commit, state }, { storeId = null } = {}) {
      if (state.locationId && state.locationId === storeId) return;

      try {
        commit('SET_LOCATION_ID', storeId);

        let route = '/cardfree-api/v1/content';
        if (storeId) route += `/stores/${storeId}`;

        const { data } = await http.get(route);

        const content = data.reduce((obj, c) => {
          obj[c.contentType] = c;
          return obj;
        }, {});

        commit('SET_CONTENT', content);
      }

      catch (error) {
        commit('SET_LOCATION_ID', null);
        errorHandlers.silent(error);
      }
    }
  },

  mutations: {
    SET_CONTENT(state, content) {
      state.content = {
        ...state.content,
        ...content
      };
    },

    SET_LOCATION_ID(state, id) {
      state.locationId = id;
    },

    SET_TERMS(state, terms) {
      state.terms = terms;
    }
  }
};
